"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemRoot = exports.FootNote = exports.Description = exports.Term = exports.List = exports.Root = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const PREFIX = "LocationDetails";
exports.classes = {
    icon: `${PREFIX}-icon`,
    label: `${PREFIX}-label`,
    link: `${PREFIX}-link`,
    footNoteText: `${PREFIX}-footNoteText`
};
exports.Root = (0, styles_1.styled)("address")(({ theme }) => ({
    padding: "20px",
    fontStyle: "normal",
    fontSize: "1rem",
    height: "100%",
    backgroundColor: theme.colours.white,
    [theme.breakpoints.up(1024)]: {
        padding: "30px"
    }
}));
exports.List = (0, styles_1.styled)("dl")({
    margin: "18px 0 0"
});
exports.Term = (0, styles_1.styled)("dt")(({ theme }) => ({
    display: "flex",
    [theme.breakpoints.up(1024)]: {
        gridColumn: 1
    },
    [`.${exports.classes.icon}`]: {
        height: "24px",
        width: "24px",
        marginRight: "12px",
        display: "none",
        color: theme.colours.slate,
        [theme.breakpoints.up(1024)]: {
            display: "inline-block"
        }
    },
    [`.${exports.classes.label}`]: {
        display: "inline-block",
        color: theme.colours.slate,
        [theme.breakpoints.up(1024)]: {
            marginBottom: 0
        },
        "&::after": {
            content: "':'",
            display: "inline"
        }
    }
}));
exports.Description = (0, styles_1.styled)("address")(({ theme }) => ({
    margin: "6px 0 18px",
    fontStyle: "normal",
    [theme.breakpoints.up(1024)]: {
        gridColumn: 2,
        margin: 0
    },
    "&:last-child": {
        marginBottom: 0
    },
    [`.${exports.classes.link}`]: {
        fontFamily: "Effra Medium",
        textDecoration: "none"
    }
}));
exports.FootNote = (0, styles_1.styled)("div")(({ theme }) => ({
    marginTop: "36px",
    [theme.breakpoints.down(1024)]: {
        marginTop: "18px"
    },
    [`.${exports.classes.footNoteText}`]: {
        fontFamily: "Effra Regular",
        color: theme.colours.charcoal,
        fontSize: "16px"
    }
}));
exports.ItemRoot = (0, styles_1.styled)("div")(({ theme }) => ({
    marginTop: "18px",
    [theme.breakpoints.up(1024)]: {
        "&:first-of-type": {
            marginTop: "32px"
        },
        marginTop: "24px",
        display: "grid",
        gridTemplateColumns: "120px 1fr",
        gap: "24px"
    }
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2xvY2F0aW9uLWRldGFpbHMvc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLGlEQUE4QztBQUU5QyxNQUFNLE1BQU0sR0FBRyxpQkFBaUIsQ0FBQztBQUVwQixRQUFBLE9BQU8sR0FBRztJQUNyQixJQUFJLEVBQUUsR0FBRyxNQUFNLE9BQU87SUFDdEIsS0FBSyxFQUFFLEdBQUcsTUFBTSxRQUFRO0lBQ3hCLElBQUksRUFBRSxHQUFHLE1BQU0sT0FBTztJQUN0QixZQUFZLEVBQUUsR0FBRyxNQUFNLGVBQWU7Q0FDdkMsQ0FBQztBQUVXLFFBQUEsSUFBSSxHQUFHLElBQUEsZUFBTSxFQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUNwRCxPQUFPLEVBQUUsTUFBTTtJQUNmLFNBQVMsRUFBRSxRQUFRO0lBQ25CLFFBQVEsRUFBRSxNQUFNO0lBQ2hCLE1BQU0sRUFBRSxNQUFNO0lBQ2QsZUFBZSxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSztJQUNwQyxDQUFDLEtBQUssQ0FBQyxXQUFXLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxDQUFDLEVBQUU7UUFDNUIsT0FBTyxFQUFFLE1BQU07S0FDaEI7Q0FDRixDQUFDLENBQUMsQ0FBQztBQUVTLFFBQUEsSUFBSSxHQUFHLElBQUEsZUFBTSxFQUFDLElBQUksQ0FBQyxDQUFDO0lBQy9CLE1BQU0sRUFBRSxVQUFVO0NBQ25CLENBQUMsQ0FBQztBQUVVLFFBQUEsSUFBSSxHQUFHLElBQUEsZUFBTSxFQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUMvQyxPQUFPLEVBQUUsTUFBTTtJQUNmLENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLENBQUMsRUFBRTtRQUM1QixVQUFVLEVBQUUsQ0FBQztLQUNkO0lBQ0QsQ0FBQyxJQUFJLGVBQU8sQ0FBQyxJQUFJLEVBQUUsQ0FBQyxFQUFFO1FBQ3BCLE1BQU0sRUFBRSxNQUFNO1FBQ2QsS0FBSyxFQUFFLE1BQU07UUFDYixXQUFXLEVBQUUsTUFBTTtRQUNuQixPQUFPLEVBQUUsTUFBTTtRQUNmLEtBQUssRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUs7UUFDMUIsQ0FBQyxLQUFLLENBQUMsV0FBVyxDQUFDLEVBQUUsQ0FBQyxJQUFJLENBQUMsQ0FBQyxFQUFFO1lBQzVCLE9BQU8sRUFBRSxjQUFjO1NBQ3hCO0tBQ0Y7SUFDRCxDQUFDLElBQUksZUFBTyxDQUFDLEtBQUssRUFBRSxDQUFDLEVBQUU7UUFDckIsT0FBTyxFQUFFLGNBQWM7UUFDdkIsS0FBSyxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSztRQUMxQixDQUFDLEtBQUssQ0FBQyxXQUFXLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxDQUFDLEVBQUU7WUFDNUIsWUFBWSxFQUFFLENBQUM7U0FDaEI7UUFDRCxVQUFVLEVBQUU7WUFDVixPQUFPLEVBQUUsS0FBSztZQUNkLE9BQU8sRUFBRSxRQUFRO1NBQ2xCO0tBQ0Y7Q0FDRixDQUFDLENBQUMsQ0FBQztBQUVTLFFBQUEsV0FBVyxHQUFHLElBQUEsZUFBTSxFQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUMzRCxNQUFNLEVBQUUsWUFBWTtJQUNwQixTQUFTLEVBQUUsUUFBUTtJQUNuQixDQUFDLEtBQUssQ0FBQyxXQUFXLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxDQUFDLEVBQUU7UUFDNUIsVUFBVSxFQUFFLENBQUM7UUFDYixNQUFNLEVBQUUsQ0FBQztLQUNWO0lBQ0QsY0FBYyxFQUFFO1FBQ2QsWUFBWSxFQUFFLENBQUM7S0FDaEI7SUFDRCxDQUFDLElBQUksZUFBTyxDQUFDLElBQUksRUFBRSxDQUFDLEVBQUU7UUFDcEIsVUFBVSxFQUFFLGNBQWM7UUFDMUIsY0FBYyxFQUFFLE1BQU07S0FDdkI7Q0FDRixDQUFDLENBQUMsQ0FBQztBQUVTLFFBQUEsUUFBUSxHQUFHLElBQUEsZUFBTSxFQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUNwRCxTQUFTLEVBQUUsTUFBTTtJQUNqQixDQUFDLEtBQUssQ0FBQyxXQUFXLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDLEVBQUU7UUFDOUIsU0FBUyxFQUFFLE1BQU07S0FDbEI7SUFDRCxDQUFDLElBQUksZUFBTyxDQUFDLFlBQVksRUFBRSxDQUFDLEVBQUU7UUFDNUIsVUFBVSxFQUFFLGVBQWU7UUFDM0IsS0FBSyxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsUUFBUTtRQUM3QixRQUFRLEVBQUUsTUFBTTtLQUNqQjtDQUNGLENBQUMsQ0FBQyxDQUFDO0FBRVMsUUFBQSxRQUFRLEdBQUcsSUFBQSxlQUFNLEVBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ3BELFNBQVMsRUFBRSxNQUFNO0lBQ2pCLENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLENBQUMsRUFBRTtRQUM1QixpQkFBaUIsRUFBRTtZQUNqQixTQUFTLEVBQUUsTUFBTTtTQUNsQjtRQUNELFNBQVMsRUFBRSxNQUFNO1FBQ2pCLE9BQU8sRUFBRSxNQUFNO1FBQ2YsbUJBQW1CLEVBQUUsV0FBVztRQUNoQyxHQUFHLEVBQUUsTUFBTTtLQUNaO0NBQ0YsQ0FBQyxDQUFDLENBQUMifQ==